import React from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';

const ClientDataGrid = ({ 
  clients, 
  selectedClients, 
  onSelectClient, 
  onSelectAll, 
  onSort, 
  sortColumn, 
  sortDirection,
  onClientClick 
}) => {
  const columns = [
    { key: 'clientId', label: 'Klienten-ID', sortable: true },
    { key: 'fullName', label: 'Vollständiger Name', sortable: true },
    { key: 'birthDate', label: 'Geburtsdatum', sortable: true },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'lastContact', label: 'Letzter Kontakt', sortable: true },
    { key: 'caseWorker', label: 'Sachbearbeiter', sortable: true },
    { key: 'location', label: 'Standort', sortable: true }
  ];

  const getStatusColor = (status) => {
    const colors = {
      'Aktiv': 'bg-success/10 text-success',
      'Inaktiv': 'bg-muted text-muted-foreground',
      'Ausstehend': 'bg-warning/10 text-warning',
      'Archiviert': 'bg-secondary/10 text-secondary'
    };
    return colors?.[status] || 'bg-muted text-muted-foreground';
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const handleSort = (columnKey) => {
    if (columns?.find(col => col?.key === columnKey)?.sortable) {
      onSort(columnKey);
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50 border-b border-border">
            <tr>
              <th className="w-12 px-4 py-3">
                <Checkbox
                  checked={selectedClients?.length === clients?.length && clients?.length > 0}
                  onChange={(e) => onSelectAll(e?.target?.checked)}
                />
              </th>
              {columns?.map((column) => (
                <th
                  key={column?.key}
                  className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider"
                >
                  <button
                    onClick={() => handleSort(column?.key)}
                    className="flex items-center gap-2 hover:text-foreground transition-colors"
                    disabled={!column?.sortable}
                  >
                    {column?.label}
                    {column?.sortable && (
                      <Icon
                        name={sortColumn === column?.key ? (sortDirection === 'asc' ? 'ChevronUp' : 'ChevronDown') : 'ChevronsUpDown'}
                        size={14}
                        className={sortColumn === column?.key ? 'text-primary' : 'text-muted-foreground'}
                      />
                    )}
                  </button>
                </th>
              ))}
              <th className="w-20 px-4 py-3"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {clients?.map((client) => (
              <tr
                key={client?.id}
                className="hover:bg-muted/30 transition-colors cursor-pointer"
                onClick={() => onClientClick(client)}
              >
                <td className="px-4 py-3" onClick={(e) => e?.stopPropagation()}>
                  <Checkbox
                    checked={selectedClients?.includes(client?.id)}
                    onChange={(e) => onSelectClient(client?.id, e?.target?.checked)}
                  />
                </td>
                <td className="px-4 py-3">
                  <span className="text-sm font-medium text-primary">{client?.clientId}</span>
                </td>
                <td className="px-4 py-3">
                  <span className="text-sm text-foreground font-medium">{client?.fullName}</span>
                </td>
                <td className="px-4 py-3">
                  <span className="text-sm text-muted-foreground">{formatDate(client?.birthDate)}</span>
                </td>
                <td className="px-4 py-3">
                  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(client?.status)}`}>
                    {client?.status}
                  </span>
                </td>
                <td className="px-4 py-3">
                  <span className="text-sm text-muted-foreground">{formatDate(client?.lastContact)}</span>
                </td>
                <td className="px-4 py-3">
                  <span className="text-sm text-foreground">{client?.caseWorker}</span>
                </td>
                <td className="px-4 py-3">
                  <span className="text-sm text-muted-foreground">{client?.location}</span>
                </td>
                <td className="px-4 py-3" onClick={(e) => e?.stopPropagation()}>
                  <button className="p-1 hover:bg-muted rounded transition-colors">
                    <Icon name="MoreVertical" size={18} className="text-muted-foreground" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ClientDataGrid;